module.exports = __webpack_public_path__ + "static/img/h6-1.0ea5d9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h6-1.png
// module id = iV4+
// module chunks = 1